// src/api/meeting.ts
import api from './client';
import type { MeetingId, MeetingRow } from '../types/domain';

/**
 * `/api/meeting/meet/{id}` returns the flat runner×race×meeting rows under
 * `data`. `fast=true` is the read-only mode: the backend skips the rating
 * recomputation and the response omits the computed overlay/stake columns.
 */
export interface MeetingResponse {
  data: MeetingRow[];
}

export const fetchMeetingData = async (
  meetingId: MeetingId,
  { fast = false }: { fast?: boolean } = {},
): Promise<MeetingResponse> => {
  try {
    const url = `/api/meeting/meet/${meetingId}${fast ? '?fast=true' : ''}`;
    return await api.get<MeetingResponse>(url);
  } catch (error) {
    console.error('fetchMeetingData error:', error);
    throw error;
  }
};

export default fetchMeetingData;
